exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.forgot--backto-login[data-v-1be2add0] {\n  margin: 0 auto;\n  font-weight: bold;\n  text-decoration: none;\n}\n.forgot__form[data-v-1be2add0] {\n  width: 45vh;\n}\n", "", {"version":3,"sources":["/var/www/appv1.carnet-info-logement.com/src/containers/forgot-password/styles.scss"],"names":[],"mappings":";AAIE;EACE,eAAc;EACd,kBAAiB;EACjB,sBAAqB;CACtB;AAED;EACE,YAAW;CACZ","file":"styles.scss","sourcesContent":["$primary:#2E038C;\n$white:white;\n\n.forgot {\n  &--backto-login {\n    margin: 0 auto;\n    font-weight: bold;\n    text-decoration: none;\n  }\n\n  &__form {\n    width: 45vh;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1be2add0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/containers/forgot-password/styles.scss
// module id = lXV3
// module chunks = 0